module.exports = __webpack_public_path__ + "static/media/altitude icon.78f2ac2c.svg";